<template>
  <!-- 显示启动图组件，通过 @skip-splash 监听跳过事件 -->
  <splash-screen v-if="showSplash" @skip-splash="handleSkipSplash" />
  <!-- 根据 type 参数值显示对应组件 -->
  <mapConfig2 v-if="!showSplash && showMapConfig2" />
  <mapConfig v-if="!showSplash && !showMapConfig2" />
</template>

<script setup>
import { ref, onMounted } from "vue";
import mapConfig2 from "./components/mapConfig2.vue";
import mapConfig from "./components/mapConfig.vue";
import splashScreen from "./components/splashScreen.vue";

// 用于存储是否显示启动图的状态
const showSplash = ref(true);
// 用于存储是否显示 mapConfig2 组件的状态
const showMapConfig2 = ref(false);

onMounted(() => {
  // 获取地址栏查询参数
  const urlParams = new URLSearchParams(window.location.search);
  // 判断是否存在 type 参数
  showMapConfig2.value = urlParams.has("pc");
  // 3 秒后隐藏启动图
  setTimeout(() => {
    showSplash.value = false;
  }, 3000);
});

// 处理跳过启动图事件
const handleSkipSplash = () => {
  showSplash.value = false;
};
</script>

<style>
/* 原有样式保持不变 */
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  background: #fef8f2;
}

.van-dialog,
.van-dialog__footer {
  background: rgba(27, 108, 99, 0.5) !important;
}

.van-dialog__confirm,
.van-dialog__confirm:active {
  color: #fff !important;
  background: rgba(27, 108, 99, 0.5) !important;
}

.van-field {
  background: rgba(27, 108, 99, 0.5) !important;
}

.van-cell {
  background: rgba(27, 108, 99, 0.5) !important;
}

.van-search .van-cell {
  background: #fff !important;
}

.van-dialog__header {
  color: #fff !important;
  background: rgba(27, 108, 99, 0.5) !important;
  padding: 10px !important;
}
</style>